import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainerComponent } from '../../layout/container/container.component';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-how-to-apply',
  standalone: true,
  imports: [CommonModule, ContainerComponent],
  templateUrl: './how-to-apply.component.html',
  styleUrls: ['./how-to-apply.component.scss']
})
export class HowToApplyComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('howToApply', { static: false }) howToApply?: ElementRef;
  whatsappNumber = '+569 58123297';
  phoneNumber = '600 390 9001';

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    // No necesita tracking de página aquí, se maneja en la página padre
  }

  ngAfterViewInit() {
    // Registrar la sección para tracking de analytics
    if (this.howToApply?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.howToApply.nativeElement,
        'How To Apply',
        'how-to-apply-section'
      );
    }
  }

  ngOnDestroy() {
    // Cleanup si es necesario
  }
}
